export { isExternalResource, urlRefsAndTarget, typeMap, isThirdPartyArticle } from './is-external-resource';
